/*
Parallax.js
 */
var Parallax = function(){
    this.$element = $('.js-parallax');
    this.elementPosition = [];
    this.isLoad = false;
    this.length = this.$element.length;
    this.innerHeight;
    this.parallaxSpan;
    this.$window = $(window);
}

Parallax.prototype = {
    init: function() {
        this.innerHeight = window.innerHeight;
        this.parallaxSpan = this.getParallaxSpan();
        for(var i = 0; i < this.length; i++){
            var $element = this.$element.eq(i);
            var offsetTop = $element.offset().top;
            var top = offsetTop;
            var bottom = offsetTop + $element.height() + this.innerHeight;
            this.elementPosition.push({top: top, bottom: bottom});
        }
    },
    getParallaxSpan: function(){
        return window.innerHeight / window.innerWidth * 3;
    },
    reset: function(){
        this.innerHeight = window.innerHeight;
        this.parallaxSpan = this.getParallaxSpan();
        this.$element = $('.js-parallax');
        this.length = this.$element.length;
        this.elementPosition = [];
        for(var i = 0; i < this.length; i++){
            var $element = this.$element.eq(i);
            var offsetTop = $element.offset().top;
            var top = offsetTop;
            var bottom = offsetTop + $element.height() + this.innerHeight;
            this.elementPosition.push({top: top, bottom: bottom});
        }
    },
    scroll: function(){
        for (var i = 0; i < this.length; i++) {
            var $target = this.$element.eq(i);
            if (!$target.hasClass('js-no-parallax')) {
                var scrollTop = this.$window.scrollTop() + this.innerHeight;
                if (scrollTop > this.elementPosition[i].top && scrollTop < this.elementPosition[i].bottom) {
                    var value = scrollTop - this.elementPosition[i].top - this.innerHeight;
                    $target.css({'background-position': 'center ' +  value / this.parallaxSpan + 'px' });
                } else {
                    $target.css({'background-position': 'center ' + 0 + 'px' });
                }
            }
        }
    }
}

module.exports = Parallax;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/Parallax.js
 **/